module.exports = __webpack_public_path__ + "img/logo-large.fb08d401.png";